/** All known AB Tests. Other parts of the code need to know ALL of the choices for an AB test, so that it can
 * generate the key used for local storage.
 *
 * Choices may be assigned on the client side or the server side. Some are saved into the abtest_variant column.
 */
export const allAbTests = {
  // Test names and values should be deleted from here when the test finishes

  // AB test groups where choices are assigned on the client side and may be saved into the abtest_variant column through an API call
  EnterFlowProgress: [
    { choice: 'CONTROL', weight: 1 },
    { choice: 'VARIANT1', weight: 1 },
    { choice: 'VARIANT2', weight: 0 },
    { choice: 'VARIANT3', weight: 0 },
  ],
  Dashboard2026: [
    { choice: 'CONTROL', weight: 0.5 },
    { choice: 'V1', weight: 0.5 },
  ],
  ChooseYourPlanBoost: [
    { choice: 'CONTROL', weight: 1 },
    { choice: 'V5', weight: 1 },
    { choice: 'ORIGINALV1', weight: 1 },
    { choice: 'ORIGINALV2', weight: 1 },
  ],
  HomePage2026: [
    { choice: 'CONTROL', weight: 8 },
    { choice: 'V1', weight: 0 },
    { choice: 'V3', weight: 2 },
  ],
  SkipChooseYourPlan2026: [
    { choice: 'CONTROL', weight: 1 },
    { choice: 'TEST', weight: 0 },
  ],
  Checkout2026: [
    { choice: 'CONTROL', weight: 1 },
    { choice: 'V1', weight: 0 },
    { choice: 'V2', weight: 0 },
  ],

  // AB test groups where choices are assigned on the server side
  MonthlyGiveaway: [
    { choice: 'CONTROL', weight: 0 },
    { choice: 'YES', weight: 1 },
  ],
  ConsolationPrize2: [
    { choice: 'CONTROL', weight: 2 },
    { choice: 'YES', weight: 4 },
    { choice: 'YES_MIN_5', weight: 4 },
  ],
  TreatWinEmails: [
    { choice: 'CONTROL', weight: 1 },
    { choice: 'TEST', weight: 1 },
  ],
} as const satisfies Record<
  string,
  Array<{ choice: string; weight: number; mobileOnly?: boolean }>
>;

/** A list of the AB tests that must be synced between frontend and backend */
export const serverSideAndClientSideTestNames: (keyof typeof allAbTests)[] = [
  // Test names should be deleted from here when the test finishes
];
